<template>
  <main id="home" class="text-center">
    <v-img id="hero-banner" position="center center" :src="require('../assets/banner.jpeg')" :aspect-ratio="40/9" light>
      <v-sheet style="height: 100%; margin: 0 -1rem;" color="rgba(0,0,0,0.1)" dark>
        <v-container class="fill-height px-8">
          <v-row justify="center">
            <v-col cols="12" md="8">
              <h2 class="text-h2 mb-4">
                Welcome to My Life Pie
              </h2>

              <h5 class="text-h6 mb-4">
                If you are struggling with any of these challenges we may be able to help.
              </h5>
              <v-img class="rounded-lg" :src="require('../assets/collage.jpg')" max-height="512px" :aspect-ratio="1.0" contain></v-img>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-img>

    <v-sheet id="idk" color="grey lighten-3">
      <v-sheet style="height: 1px" color="grey lighten-1"></v-sheet>
      <v-container style="max-width: 1280px">
        <v-row justify="center">
          <v-col cols="12" lg="8">
            <p class="text-body-1 mb-4">
              Several years ago, I went through what I perceived as a very tough time. It involved divorce, bankruptcy, health issues, missing my child, 
              a lawsuit, loss of hope and a ton of other problems. My life was a mess. I thought about all the options. Then one night, in desperation, 
              I said a prayer and God gave me an idea. For the next several hours I worked on this idea, through the darkness, through the tears, 
              pain and anger…then, finally, the answer presented itself.
            </p>
            <p class="text-body-1 font-weight-bold mb-0">
              This Changed Everything
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <!-- Blurb -->
    <v-sheet id="blurb">
      <v-sheet style="height: 1px" color="grey lighten-1"></v-sheet>
      <v-container class="pb-4" style="max-width: 1280px">
        <v-row justify="center">
          <v-col class="text-left" cols="12" lg="4">
            <h5 class="text-h6 mb-4">
              To this day I use this system to find peace.
            </h5>
            <ul>
              <li class="text-body-1">
                Things hurt worse when you don’t have the correct perspective.
              </li>
              <li class="text-body-1">
                This tool is not instant, it will not solve all of your problems, it is not perfect in every way.
              </li>
              <li class="text-body-1">
                But if you try it, and actually make an effort,
                I believe you will feel better and be in a better position to work out your problems.
              </li>
            </ul>
          </v-col>
          <v-col cols="12" lg="4" order="first" order-sm="first" order-md="last">
            <v-img class="rounded-lg" :src="require('../assets/risk.jpg')" :aspect-ratio="16/10">

            </v-img>
          </v-col>
        </v-row>

        <v-row justify="center">
          <v-col cols="12" lg="4">
            <v-img class="rounded-lg" :src="require('../assets/charts.jpg')" :aspect-ratio="16/10"></v-img>
          </v-col>
          <v-col class="text-left" cols="12" lg="4">
            <h5 class="text-h6 mb-4">
              I hope you will try it and think about it.
            </h5>
            <ul>
              <li class="text-body-1">
                I have used this tool for breakups, death of a loved ones, financial issues, health issues, mental health issues/worry, loss of hope and more.
              </li>
              <li class="text-body-1">
                Originally it took hours and was all on paper, now you can do it quickly.
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet id="idk" color="grey lighten-3">
      <v-sheet style="height: 1px" color="grey lighten-1"></v-sheet>
      <v-container style="max-width: 1280px">
        <v-row justify="center">
          <v-col cols="auto" lg="8">
            <p class="text-h6 blue--text font-weight-bold">
              I hope this tool helps you as much as it has helped me.
            </p>
            <p class="text-h6">
              After you use it, if it was helpful, please contribute $2.
              This helps us, help others.
            </p>
            <p class="text-h6">
              Also, please leave feedback or suggestions so we can improve the experience for those who really need it.
            </p>
            <p class="text-h6">
              Thank you!<br>
              This tool is most helpful with honest answers.
            </p>
            <p class="text-h6 blue--text font-weight-bold">
              If you are ready to feel better, let's get started.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <v-sheet>
      <v-sheet style="height: 1px" color="grey lighten-1"></v-sheet>
      <v-container>
        <v-card v-if="loggedIn">
          <v-overlay :value="!formReady" absolute>
            <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
          </v-overlay>
          <v-card-text>
            <v-container>
              <v-row justify="center">
                <v-col>
                  <h6 class="text-h6">
                    Welcome Back
                  </h6>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="10">
                  <stripe-checkout
                    ref="checkoutRef"
                    mode="payment"
                    :pk="publishableKey"
                    :line-items="lineItems"
                    :success-url="successURL"
                    :cancel-url="cancelURL"
                    @loading="v => loading = v"
                  />
                  <v-btn class="mx-2 mb-5" color="primary" @click="startPie" block rounded x-large>
                    Start Pie
                    <v-icon right>
                      mdi-chart-pie
                    </v-icon>
                  </v-btn>
                  <h5 class="text-h7 mb-0">
                    352 Taken
                  </h5>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>

        <v-card v-if="!loggedIn">
          <v-form v-model="valid" @submit.prevent="login">
            <v-container class="px-8">
              <v-row justify="center">
                <v-col>
                  <h6 class="text-h6">
                    Welcome Back
                  </h6>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    :rules="passwordRules"
                    :counter="16"
                    label="Password"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-btn color="primary" type="submit" :disabled="!valid" block>
                    Sign In
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <p class="text-overline mb-0">
                    or sign in with
                  </p>
                </v-col>
                <v-col cols="12">
                  <v-btn color="error" @click="loginGoogle">
                    Google
                    <v-icon right>
                      mdi-google
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <a href="/forgot">Forgot password?</a>
                </v-col>
                <v-col cols="12">
                  <small classs="text-caption">
                    Don't have an account?<br>
                    <a href="/register">Click here</a> to register.
                  </small>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-container>
    </v-sheet>
  </main>
</template>

<script>
import firebase from 'firebase';
import { StripeCheckout } from '@vue-stripe/vue-stripe';
export default {
  components: {
    StripeCheckout,
  },
  data: () => ({
    dialog: false,

    loggedIn: false,
    hasPaid: false,
    formReady: false,
    voucherCode: "",

    valid: false,
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid',
    ],

    password: '',
    passwordRules: [
      v => !!v || 'Password is required',
      v => v.length > 7 || 'Password must be at least 8 characters.',
      v => v.length <= 16 || 'Password must be less than 16 characters.',
    ],

    // Stripe stuff.
    publishableKey: "pk_test_51J892fDy6ozJcsSrAA8IzOmLgnJvviTZgWjOagEqqtROlpEIlUH0Pmrr0ZOBCp7aYz6XDjHk0PtwPYkflju5c3RP00T8EzqL6H",
    loading: false,
    lineItems: [
      {
        price: 'price_1JCoThDy6ozJcsSrcnSsvEXC', // The id of the one-time price you created in your Stripe dashboard
        quantity: 1,
      },
    ],
    successURL: 'http://mylifepie.com/paymentsuccess',
    cancelURL: 'http://mylifepie.com/',
  }),

  mounted () {
    //this.checkLogin();
    this.loggedIn = true;
    this.formReady = true;
  },

  methods: {
    checkLogin: function() {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          this.loggedIn = true;

          // If the user is autnenticated, retrieve their session token.
          firebase.auth().currentUser.getIdToken(true).then(idToken => {
            const t = { token: idToken };
            this.$http.post("https://us-central1-waldock-my-life-pie.cloudfunctions.net/api/check-payment", t).then(() => {
              this.hasPaid = true;
              this.formReady = true;
            });
          }).catch(function(error) {
            alert(error);
          });
        } 
        else {
          this.loggedIn = false;
          this.formReady = true;
        }
      });
    },

    checkVoucher: function() {
      if (this.voucherCode.toUpperCase() == "MLP2021") {
        return true;
      }

      return false;
    },

    login: function() {
      firebase
      .auth()
      .signInWithEmailAndPassword(this.email, this.password)
      .then(() => {
        alert('Successfully logged in');
        this.$forceUpdate();
      })
      .catch(error => {
        alert(error.message);
      });
    },

    loginGoogle: function() {
      var provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');

      firebase.auth().signInWithPopup(provider).then(() => {
        alert('Successfully logged in');
        this.$forceUpdate();
      }).catch(error => {
        alert(error.message);
      });
    },

    startPie: function() {
      this.$router.push('/pre-quiz');
    }
  },
}
</script>